<template>
  <main class="home-page">
    <section class="section hero-section">
      <div class="wrapper">
        <div class="left">
          <div class="title big">
            {{ $t("The Dream of PUBG skins collectors.") }}
          </div>
          <div class="desc">
            {{ $t("Stand out with your favorite skins!") }}
          </div>

          <button
            v-if="!isAuth"
            class="button home"
            @click="$emit('openSignUp')"
          >
            {{ $t("lets_start") }}
          </button>

          <router-link v-if="isAuth" to="/products/all" class="button home">
            {{ $t("lets_start") }}
          </router-link>
        </div>

        <div class="item item1 hero-image">
          <img src="./../assets/img/hero1.png" class="img" />
          <!-- <img src="./../assets/img/hero1Shadow.png" class="shadow"> -->
          <img src="./../assets/img/line.svg" class="line" />
          <div class="text">
            <div class="desc blue">
              <b>{{ $t(`pan`) }}</b>
            </div>
            <div class="desc big">
              <b>{{ $t(`The olive branch`) }}</b>
            </div>
          </div>
        </div>
        <div class="item item2 hero-image">
          <img src="./../assets/img/hero2.png" class="img" />
          <!-- <img src="./../assets/img/hero2Shadow.png" class="shadow"> -->
          <img src="./../assets/img/line.svg" class="line" />
          <div class="text">
            <div class="desc blue">
              <b>{{ $t(`Kar98k`) }}</b>
            </div>
            <div class="desc big">
              <b>{{ $t(`Orange`) }}</b>
            </div>
          </div>
        </div>
      </div>
    </section>

    <StatSection />

    <ProductCarousel
      :title="$t(`Best seller`)"
      apiEndpoint="items/rand-type-items"
      showAllLink="/products/all"
      @goToProduct="goToProduct"
    />

    <!-- <section class="section about-section">
      <div class="wrapper">
        <div class="title">
          {{ $t('About us') }}
        </div>
        <div class="item item-main">
          <div class="title small">{{ $t(`Topnotch trading experience for every CS2 fan`) }}</div>
        </div>
        <div class="flex">
          <div class="item">
            <div class="desc medium">
              <b>{{ $t('Extensive collection') }}</b>
            </div>
            <div class="desc big blue">
              01
            </div>
          </div>
          <div class="item">
            <div class="desc medium">
              <b>{{ $t('Customer-centric experience') }}</b>
            </div>
            <div class="desc big blue">
              02
            </div>
          </div>
          <div class="item">
            <div class="desc medium">
              <b>{{ $t('Secure and seamless transactions') }}</b>
            </div>
            <div class="desc big blue">
              03
            </div>
          </div>
        </div>
      </div>
    </section> -->

    <!-- <UnleashSection /> -->

    <!-- <section class="section home-products-section">
      <div class="wrapper">
        <div class="top">
          <div class="title">
            {{ $t('Hot deals') }}
          </div>
          <router-link to="/products/all" class="desc blue">
            {{ $t('View all') }}
          </router-link>
        </div>
        <Transition>
          <div v-if="saleProducts && saleProducts.length" class="products">
            <div v-for="(item, i) in saleProducts.slice(0, 5)" :key="i" class="item">
              <ProductCard :item="item" :currencySymbol="currencySymbol" :sale="true" @goToProduct="goToProduct" />
            </div>
          </div>
        </Transition>
      </div>
    </section> -->

    <!-- <section class="section last-sales-section">
      <LastSales :currencySymbol="currencySymbol" @goToProduct="goToProduct" />
    </section> -->

    <!-- <section class="section packs-of-random-section">
      <RandomCasesSlider :currencySymbol="currencySymbol" :currencyCode="currencyCode" @goToProduct="goToProduct" />
    </section> -->

    <!-- <SecureAndAffordable /> -->

    <FeaturesSection />

    <ProductCarousel
      :title="$t(`Most Popular`)"
      apiEndpoint="items/rand-type-items"
      showAllLink="/products/all"
      @goToProduct="goToProduct"
    />

    <section class="section faq-section" v-if="faq && faq.length">
      <div class="wrapper">
        <FaqSection :faq="faq" :title="$t(`Frequently Asked Questions`)" />
      </div>
    </section>

    <PaymentMethodsSection />

    <!-- <WhatsNew /> -->
  </main>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
// import RandomCasesSlider from "../components/RandomCasesSlider.vue";
// import LastSales from "../components/LastSales.vue";
import StatSection from "../components/StatSection.vue";
// import UnleashSection from "../components/UnleashSection.vue";
// import SecureAndAffordable from "../components/SecureAndAffordable.vue";
import FeaturesSection from "../components/FeaturesSection.vue";
// import WhatsNew from "../components/WhatsNew.vue";
import FaqSection from "../components/FaqSection.vue";
import ProductCarousel from "@/components/ProductCarousel.vue";
import PaymentMethodsSection from "@/components/PaymentMethodsSection.vue";
export default {
  name: "HomePage",
  components: {
    // RandomCasesSlider,
    // LastSales,
    StatSection,
    // UnleashSection,
    // SecureAndAffordable,
    FeaturesSection,
    // WhatsNew,
    FaqSection,
    ProductCarousel,
    PaymentMethodsSection,
  },
  props: {
    currencySymbol: {
      type: String,
      required: true,
    },
    isAuth: {
      type: Boolean,
      required: true,
    },
    currencyCode: {
      type: String,
      required: true,
    },
  },
  data: function () {
    return {
      saleProducts: [],
      newArrivals: [],
      activePanels: [],
      faq: [],
    };
  },
  computed: {
    ...mapGetters("app", ["currentLanguage"]),
  },
  watch: {
    currencyCode() {
      this.getNewArrivals();
      this.getSale();
    },
  },
  async mounted() {
    this.getSale();
    this.getNewArrivals();
    this.getFaq();
    if (this.isAuth) {
      await this.fetchActiveDiscount(this.currencyCode);
      if (this.hasActiveDiscount) {
        this.openDiscountModal();
      }
    }
  },
  methods: {
    ...mapActions("discount", ["fetchActiveDiscount"]),
    getFaq() {
      this.$http
        .get(
          process.env.VUE_APP_API + "faqs" + "?lang_id=" + this.currentLanguage
        )
        .then((res) => {
          this.faq = res.data.payload;
        })
        .catch(() => {});
    },
    getNewArrivals() {
      this.$http
        .get(
          process.env.VUE_APP_API +
            "items/list?new=true&currency=" +
            this.currencyCode
        )
        .then((res) => {
          this.newArrivals = res.data.payload;
        })
        .catch(() => {});
    },
    getSale() {
      this.$http
        .get(
          process.env.VUE_APP_API +
            "items/list?sale=true&currency=" +
            this.currencyCode
        )
        .then((res) => {
          this.saleProducts = res.data.payload;
        })
        .catch(() => {});
    },
    goToProduct(item) {
      this.$emit("goToProduct", item);
    },
    togglePanel(index) {
      if (this.isActivePanel(index)) {
        this.activePanels.splice(this.activePanels.indexOf(index), 1);
      } else {
        this.activePanels.push(index);
      }
    },
    isActivePanel(index) {
      return this.activePanels.includes(index);
    },
  },
};
</script>

<style scoped lang="scss">
.hero-section .wrapper {
  padding-bottom: 180px;
}

.hero-top {
  position: absolute;
  right: -20px;
  top: -137px;
  transform: rotate(-15deg);
  width: 416px;
  height: 416px;
}

.hero-bottom {
  position: absolute;
  width: 423px;
  height: 423px;
  top: 244px;
  right: 42px;
  z-index: 1;
}

.item1 img,
.item2 img {
  pointer-events: none;
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  cursor: not-allowed;
}

.item1 .text,
.item2 .text {
  z-index: 2;
}

.item1 {
  position: absolute;
  top: -60px;
  right: 87px;
  display: flex;
  align-items: center;
  justify-content: center;

  .img {
    z-index: 1;
    position: relative;
  }

  .shadow {
    position: absolute;
  }

  .line {
    position: absolute;
    top: 179px;
    right: 102px;
    width: 150px;
  }

  .text {
    position: absolute;
    top: 222px;
    right: 163px;
    text-align: center;
    width: max-content;
  }
}

.item2 {
  position: absolute;
  top: 226px;
  right: 170px;
  display: flex;
  align-items: center;
  justify-content: center;

  .img {
    z-index: 1;
    position: relative;
  }

  .shadow {
    position: absolute;
  }

  .line {
    position: absolute;
    top: 154px;
    right: 212px;
    width: 150px;
  }

  .text {
    position: absolute;
    top: 197px;
    right: 380px;
    text-align: center;
    width: max-content;
  }
}
</style>
